import { getUserContextDataMemoized } from 'common-js/api/util';
import { useAppSelector } from 'common-js/hooks';
import useAppDispatch from 'common-js/hooks/useAppDispatch';
import { selectIsSuperAdmin } from 'common-js/reducers/account/selectors';
import bulkDeviceChangePlan from 'common-js/reducers/devices/actions/bulkDeviceChangePlan';
import { useCallback } from 'react';

const useOnBulkUpdatePlan = () => {
  const dispatch = useAppDispatch();
  const isSuperAdmin = useAppSelector(selectIsSuperAdmin);
  const userContext = useAppSelector(getUserContextDataMemoized);
  const orgId = userContext.isInOrgContext ? userContext.orgId : userContext.userOrgId;

  return useCallback(
    async (devices: Array<DeviceId>, page: string = 'SIM Inventory') => {
      await dispatch(bulkDeviceChangePlan(devices, page, isSuperAdmin ? undefined : orgId));
    },
    [dispatch, isSuperAdmin, orgId]
  );
};

export default useOnBulkUpdatePlan;
